// Offene Aufgaben des Projekts für Diagramm und Prozess-Panel: einmal laden, alle 15 s nachladen, solange sichtbar.
// Wer Aufgaben ändert (Panel, Aufgabenansicht), ruft offeneAufgabenLaden() auf, damit Zähler gleich stimmen.
import { useEffect, useSyncExternalStore } from 'react';
import { api, type Aufgabe } from './api';

const NACHLADEN_MS = 15_000;

let projekt = '';
let liste: Aufgabe[] = [];
let stand = 0;
let laeuft: Promise<void> | null = null;
const listeners = new Set<() => void>();
const melden = () => { stand++; for (const l of listeners) l(); };
const abonnieren = (fn: () => void) => (listeners.add(fn), () => void listeners.delete(fn));

export function offeneAufgabenLaden(projektId: string): Promise<void> {
  if (projektId !== projekt) { projekt = projektId; liste = []; laeuft = null; melden(); }
  laeuft ??= api.aufgaben(projektId, { erledigt: false })
    .then((l) => { if (projekt === projektId) { liste = l; melden(); } })
    .catch(() => { /* Nachladen versucht es erneut */ })
    .finally(() => { laeuft = null; });
  return laeuft;
}

/** Alle offenen Aufgaben des Projekts; lädt nach, solange die Komponente sichtbar ist. */
export function useOffeneAufgaben(projektId: string): Aufgabe[] {
  useSyncExternalStore(abonnieren, () => stand);
  useEffect(() => {
    void offeneAufgabenLaden(projektId);
    const t = window.setInterval(() => void offeneAufgabenLaden(projektId), NACHLADEN_MS);
    return () => window.clearInterval(t);
  }, [projektId]);
  return projekt === projektId ? liste : [];
}

/** Anzahl offener Aufgaben je Schritt (für die Plakette im Diagramm). */
export function offeneJeSchritt(aufgaben: Aufgabe[]): Record<string, number> {
  const z: Record<string, number> = {};
  for (const a of aufgaben) if (!a.erledigt && a.bezugTyp === 'schritt' && a.bezugId) z[a.bezugId] = (z[a.bezugId] ?? 0) + 1;
  return z;
}
